import { Link } from 'react-router';
import { Github, Linkedin, Twitter } from 'lucide-react';
import { Brand } from './brand';

const COLUMNS = [
  {
    title: 'Product',
    links: [
      { label: 'Features', to: '/features' },
      { label: 'Pricing', to: '/pricing' },
      { label: 'Modules', to: '/features#students' },
      { label: 'Changelog', to: '/features#whats-new' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About', to: '/#about' },
      { label: 'Contact', to: '/contact' },
      { label: 'Customers', to: '/#customers' },
      { label: 'Careers', to: '/#careers' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Documentation', to: '/#docs' },
      { label: 'Support', to: '/contact' },
      { label: 'System status', to: '/#status' },
      { label: 'Security', to: '/#security' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy', to: '/#privacy' },
      { label: 'Terms', to: '/#terms' },
      { label: 'DPA', to: '/#dpa' },
      { label: 'Cookies', to: '/#cookies' },
    ],
  },
] as const;

export function SiteFooter() {
  return (
    <footer
      className="mt-24 border-t"
      style={{ borderColor: 'var(--border-hair)', background: 'var(--bg-sunken)' }}
    >
      <div className="mx-auto max-w-6xl px-6 py-16">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-6">
          <div className="col-span-2">
            <Brand size={36} weight="medium" />
            <p
              className="mt-4 max-w-xs text-[13px] leading-relaxed"
              style={{ color: 'var(--fg-low)' }}
            >
              The operating system for modern schools — students, fees, finance, payroll
              and library in one calm suite.
            </p>
            <div className="mt-6 flex items-center gap-2">
              {[Twitter, Linkedin, Github].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label="Social link"
                  className="flex h-8 w-8 items-center justify-center rounded-md transition-colors"
                  style={{
                    border: '1px solid var(--border-line)',
                    background: 'var(--bg-surface)',
                    color: 'var(--fg-mid)',
                  }}
                >
                  <Icon className="h-3.5 w-3.5" />
                </a>
              ))}
            </div>
          </div>
          {COLUMNS.map((col) => (
            <div key={col.title}>
              <h4
                className="text-[11px] font-semibold uppercase tracking-wider"
                style={{ color: 'var(--fg-low)', letterSpacing: '0.08em' }}
              >
                {col.title}
              </h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="text-[13px] transition-colors hover:underline"
                      style={{ color: 'var(--fg-mid)' }}
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div
          className="mt-14 flex flex-col items-start justify-between gap-3 border-t pt-6 md:flex-row md:items-center"
          style={{ borderColor: 'var(--border-hair)' }}
        >
          <p className="text-[12px]" style={{ color: 'var(--fg-low)' }}>
            © {new Date().getFullYear()} Edupra. All rights reserved.
          </p>
          <p
            className="text-[11px] uppercase tracking-wider"
            style={{ color: 'var(--fg-faint)', letterSpacing: '0.08em' }}
          >
            Built for schools, by people who&apos;ve run them.
          </p>
        </div>
      </div>
    </footer>
  );
}
